<template>
  <el-dialog
    title="值勤紀錄"
    custom-class="clockNoteDialog"
    :visible.sync="dialogVisible"
    width="20%"
    @close="closeDialog"
  >
    <el-form
      ref="feePeriodEdit"
      status-icon
      @submit.native.prevent
    >
      <el-form-item label="上班打卡備註">
        <el-input
          v-model="inRemark"
          type="textarea"
          maxlength="50"
          :autosize="{ minRows: 3}"
          resize="none"
        />
      </el-form-item>
      <el-form-item label="下班打卡備註">
        <el-input
          v-model="outRemark"
          :disabled="!isClockOut"
          type="textarea"
          maxlength="50"
          :autosize="{ minRows: 3}"
          resize="none"
        />
      </el-form-item>
      <el-form-item label="當日執勤紀錄">
        <el-input
          v-model="dutyRecord"
          type="textarea"
          maxlength="200"
          :autosize="{ minRows: 3}"
          resize="none"
        />
      </el-form-item>
      <el-form-item label="未完成事項交接">
        <el-input
          v-model="handover"
          type="textarea"
          maxlength="200"
          :autosize="{ minRows: 3}"
          resize="none"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button
        round
        @click="clickClose"
      >
        取消
      </el-button>
      <el-button
        type="primary"
        round
        @click="clickSubmit()"
      >
        送出
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { debounce } from 'lodash'

export default {
  props: {
    remarkUpdate: {
      type: Function
    }
  },
  data () {
    return {
      inRemark: '',
      outRemark: '',
      dutyRecord: '',
      handover: '',
      remarkId: '',
      isClockOut: true,
      dataIndex: 0,
      dialogVisible: false,
      loading: false,
      imgUrl: ''
    }
  },
  methods: {
    // 開啟彈窗
    async openDialog ({ remarkId, inRemark, outRemark, dutyRecord, handover, dataIndex, isClockOut }) {
      this.inRemark = inRemark
      this.outRemark = outRemark
      this.dutyRecord = dutyRecord
      this.handover = handover
      this.remarkId = remarkId
      this.dataIndex = dataIndex
      this.isClockOut = isClockOut
      this.dialogVisible = true
    },
    clickSubmit: debounce(async function () {
      // * 記得防連點
      // * 呼叫 API 儲存
      const [result] = await this.updateRemarkApi(this.remarkId, this.inRemark, this.outRemark, this.isClockOut, this.dutyRecord, this.handover)
      if (result) {
        this.$message({
          message: '差勤備註修改成功',
          type: 'success'
        })
        // * 更新列表上舊的資料
        this.remarkUpdate(this.inRemark, this.outRemark, this.dutyRecord, this.handover, this.dataIndex)
        this.dialogVisible = false
      } else {
        this.$message({
          message: '差勤備註修改失敗',
          type: 'error'
        })
      }
    }, 500),
    clickClose () {
      this.dialogVisible = false
    },
    closeDialog () {
      this.inRemark = ''
      this.outRemark = ''
      this.remarkId = ''
    },
    // * 頁面與後端 API 連接的處理層
    updateRemarkApi (ClockId, ClockInNote, ClockOutNote, isClockOut, DutyRecordNote, HandoverMattersNote) {
      // * 還沒下班以前不會傳下班備註回去後端
      const data = {
        ClockInNote,
        ClockOutNote: isClockOut ? ClockOutNote : undefined,
        DutyRecordNote,
        HandoverMattersNote
      }
      return apiAttendanceManagement.Record.PutListRemark({ ClockId }, data)
        .then(res => [res.data.Status, null])
        .catch(_ => [null, '這裡的錯誤可以以後再處理'])
    }
  }
}
</script>
<style lang="sass" scoped>
::v-deep .el-dialog.clockNoteDialog
  +basicDialog
  min-width: 540px
  .el-dialog__body
    padding-top: 24px
    padding-bottom: 15px
    .el-button
      display: block
      margin: 5px auto 0px
  .el-dialog__footer
    text-align: center
</style>
